<template>
  <v-container>
    <h1 class="title">Peeps Utils</h1>
    <span
      >Utility components for
      <a href="https://peepsportal.org" target="_blank"
        >peepsportal.org</a
      ></span
    >
    <v-divider class="my-3"></v-divider>
    <v-list nav>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="feature in features"
          :key="feature.title"
          :to="feature.to"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ feature.title }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ feature.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          title: 'GPS Coordinates to GeoJSON',
          description:
            'Convert array of coordinates to required GeoJSON format',
          to: '/coordinates-to-geojson',
        },
      ],
    };
  },
};
</script>

<style>
</style>
